import { render, staticRenderFns } from "./MoleculeCardImageTextTitle.vue?vue&type=template&id=24712a2d&scoped=true"
import script from "./MoleculeCardImageTextTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeCardImageTextTitle.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24712a2d",
  null
  
)

export default component.exports